import { createAsyncThunk } from "@reduxjs/toolkit";

import ThunkResponse from "../../models/thunk-response";

import CreateFetchInit from "../../utils/create-fetch-init";
import { endpoints } from "./endpoints";

export type AskQuestionPayload = {
    question: string;
    tenant_override_id?: string;
    userId: string;
    token?: string;
};

export const askQuestion = createAsyncThunk<
    ThunkResponse<ReadableStream<Uint8Array> | null>,
    AskQuestionPayload
>("qna/post", async (payload) => {
    try {
        const { token, ...body } = payload;
        const response = await fetch(endpoints.ask, CreateFetchInit("POST", body, token));

        const status = response.status;
        const data = response.body;

        return { status, data };
    } catch (e) {
        console.error(
            "Exception thrown in thunk askQuestion",
            (e as any)?.message,
        );
        return Promise.reject();
    }
});
